import { useEffect, useRef } from "react";
import { sampleEkg } from "../lib/ekg";
import { drawGrid, drawTrace, setupCanvas } from "./MonitorStrip";

// Renders a frozen 5-second strip for a rhythm (used by flashcards).
export function StaticStrip({ params, seconds = 5, className = "h-40" }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !params) return;
    const { ctx, cleanup } = setupCanvas(canvas);
    const { width: w, height: h } = canvas.getBoundingClientRect();
    const n = Math.ceil(w * 2);
    const points = Array.from({ length: n }, (_, i) => sampleEkg((i / n) * seconds, params));
    ctx.fillStyle = "hsl(240 10% 4%)";
    ctx.fillRect(0, 0, w, h);
    drawGrid(ctx, 0, 0, w, h);
    drawTrace(ctx, points, 0, 0, w, h, 0.3, 8);
    return cleanup;
  }, [params, seconds]);
  return <canvas ref={canvasRef} data-testid="static-strip" className={`w-full block ${className}`} />;
}
